import { computed, inject, Injectable, Signal, signal, WritableSignal } from "@angular/core";
import { FloorPlanInfo } from "../interfaces/interfaces";
import { ApiService } from "../services/api-services/api.service";
import { catchError, firstValueFrom, of, tap } from "rxjs";
import { UserStore } from "./user.store";

@Injectable({
  providedIn: 'root'
})
export class FloorplanStore {
  private _allFloorplanSignal : WritableSignal<FloorPlanInfo[]> = signal<FloorPlanInfo[]>([]);
  private _loadingSignal : WritableSignal<boolean> = signal<boolean>(false);

  private _lastFetchTime : WritableSignal<number> = signal<number>(0);

  public allFloorplansList : Signal<FloorPlanInfo[]> = this._allFloorplanSignal.asReadonly();

  public favoriteFloorplansList : Signal<FloorPlanInfo[]> = computed(() => this._allFloorplanSignal().filter(floorplan => this.userStore.userPreferences().userFavoriteMaps.includes(floorplan._id)));
  public notFavoriteFloorplansList : Signal<FloorPlanInfo[]> = computed(() => this._allFloorplanSignal().filter(floorplan => !this.userStore.userPreferences().userFavoriteMaps.includes(floorplan._id)));
  
  public loading : Signal<boolean> = this._loadingSignal.asReadonly();


  private apiService: ApiService = inject(ApiService);
  private userStore: UserStore = inject(UserStore);
  constructor() {
  }


  // Actions
  public resetStoreData() {
    this._allFloorplanSignal.set([]);
    this._loadingSignal.set(false);
  }
//   Api calls
  getFloorplanList() {
    const currentTime = Date.now();
    const timeSinceLastFetch = currentTime - this._lastFetchTime();

    // If less than 1 hour has passed, skip fetching
    if (timeSinceLastFetch < 3600000) {
      console.log('Skipping floorplan fetch - last fetch was', Math.round(timeSinceLastFetch / 60000), 'minutes ago');
      return Promise.resolve();
    }

    this._loadingSignal.set(true);
    return firstValueFrom(this.apiService.getFloorPlanInfo().pipe(
      tap((floorplan: FloorPlanInfo[]) => {
        this._allFloorplanSignal.set(floorplan);
        this._loadingSignal.set(false);

        // Update the last fetch time on successful fetch
        this._lastFetchTime.set(currentTime);
      }),
      catchError((error) => {
        console.error('Error fetching floorplan', error);
        this._loadingSignal.set(false);
        return of([]);
      })
    ));
  }



//   Helpers

  public filterFloorplans(floorplan: FloorPlanInfo, searchQuery: string) {
    if(searchQuery == "") return true;
    return Object.keys(floorplan).some(key => {
        if (!["_id", "organisationId", "lastUpdate", "floorMapImage"].includes(key)) {
          let keyValue = floorplan[key];
          return keyValue?.toString().toLowerCase().includes(searchQuery.toLowerCase());
        }
        return false;
      });
  }

  
}